module.exports = __webpack_public_path__ + "img/deleted.1178c867.svg";